import {HttpClient, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommercialFile} from "../models/commercialFile";
import {CommercialFileEnergy} from '../models/commercialFileEnergy';


const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/commercialFileEnergy';

@Injectable()
export class CommercialFileEnergyService {

    constructor(private http: HttpClient) {
    }

    findByPage(p: number, size: number): Observable<any> {
        const params = new HttpParams()
            .set('page', String(p)).set('pageSize', String(size));
        const url = `${apiUrl}/findByPage`;
        return this.http.get<any>(url, {params});
    }

    getById(id: number) {
        const url = `${apiUrl}/details/${id}`;
        return this.http.get<any>(url);
    }

    dupliquer(id: number) {
        const url = `${apiUrl}/dupliquer/${id}`;
        return this.http.get<any>(url);
    }

    delete(id: number) {
        const url = `${apiUrl}/${id}`;
        return this.http.delete<any>(url, httpOptions);
    }

    create(commercialFile: CommercialFileEnergy) {
        return this.http.post<CommercialFile>(apiUrl + '/create', commercialFile, httpOptions);
    }

    update(commercialFile: CommercialFileEnergy) {
        const url = `${apiUrl}/update/${commercialFile.id}`;
        return this.http.put(url, commercialFile, httpOptions);
    }

    updateStatus(id, status) {
        const url = `${apiUrl}/status/${id}/${status}`;
        return this.http.put(url, null, httpOptions);
    }

    findAllForUser(userId: number, selectedEquipesId: number, isForFistCallUser: boolean, p, size, status?: string[]) {
        let params = new HttpParams()
            .set('userId', String(userId))
            .set('page', String(p))
            .set('pageSize', String(size));


        if (isForFistCallUser) {
            params = params.set('isForFistCallUser', String(isForFistCallUser));
        }
        if (status) {
            params = params.set('status', String(status));
        }
        if (selectedEquipesId) {
            params = params.set('equipeId', String(selectedEquipesId));
        }

        const url = `${apiUrl}/all_by_users`;
        return this.http.get<any>(url, {params});
    }

    findAllForCurrentUser(p, size) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        return this.findAllForUser(currentUser.id, -1,null, p, size);
    }

    findAllForByUser(userId: number, selectedEquipesId: number, p, size, status?: string[]) {
        return this.findAllForUser(userId, selectedEquipesId, null, p, size, status);
    }

    findAllForByUserAndQualificationDate(userId: number, selectedEquipesId: number, p, size,
                                         qualifDateDebut: string, qualifDateFin: string,
                                         status?: string[], qualifierUserId?: number) {
        let params = new HttpParams()
            .set('userId', String(userId))
            .set('page', String(p))
            .set('pageSize', String(size))
            .set('qualifDateDebut', qualifDateDebut)
            .set('qualifDateFin', qualifDateFin);
        if (status) {
            params = params.set('status', String(status));
        }
        if (selectedEquipesId) {
            params = params.set('equipeId', String(selectedEquipesId));
        }
        if (qualifierUserId) {
            params = params.set('qualifierUserId', String(qualifierUserId));
        }
        const url = `${apiUrl}/all_by_users/by_qualification_date`;
        return this.http.get<any>(url, {params});
    }

    search(searchParams: any, p: number, size: number): Observable<any> {
        const url = `${apiUrl}/search?page=` + String(p) + '&pageSize=' + String(size);
        return this.http.post<any>(url, searchParams, httpOptions);
    }

    export(searchParams: any): Observable<any> {
        // @ts-ignore
        return this.http.post<Blob>(`${apiUrl}/export/excel`, searchParams,
            {
                headers: new HttpHeaders({'Content-Type': 'application/json'}),
                responseType: 'blob' as 'json'
            });
    }

    exportDemandeCotation(id: number): Observable<any> {
        // @ts-ignore
        return this.http.post<Blob>(`${apiUrl}/export-demande-cotation/` + id, {},
            {
                headers: new HttpHeaders({'Content-Type': 'application/json'}),
                responseType: 'blob' as 'json'
            });
    }

    importExcel(fileToUpload: File): Observable<boolean> {
        const endpoint = `${apiUrl}/import-excel`;
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        // @ts-ignore
        return this.http
            .post<any>(endpoint, formData, {
                reportProgress: true,
                observe: 'events'
            });
    }

}
